/**
 * <sticky-mobile-bottom> — compact ATC bar that slides up from below.
 * Controlled externally by <sticky-mobile-top> via dataset.visible.
 */
class StickyMobileBottom extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('.sticky-bottom');
    this.labelEl = this.btn.querySelector('.sticky-bottom__label');
    this.priceEl = this.btn.querySelector('.sticky-bottom__price');

    // Configurable selector — override via data-form-selector attribute
    // to reuse in sections with different form markup.
    this.formSel = this.dataset.formSelector || 'form.product-single__form';

    this.btn.addEventListener('click', this.onAddToCart.bind(this));
  }

  updateVariant({ price, available }) {
    if (this.priceEl) this.priceEl.textContent = price;
    if (available) {
      this.btn.disabled = false;
      this.labelEl.textContent = 'Add to Cart';
    } else {
      this.btn.disabled = true;
      this.labelEl.textContent = 'Sold Out';
    }
  }

  async onAddToCart() {
    const mainSelect = document.querySelector(`${this.formSel} select[name="id"]`);
    const variantId = mainSelect ? parseInt(mainSelect.value, 10) : null;
    if (!variantId) return;

    this.btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const data = await res.json();

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: data, addToCartBtn: this.btn },
      }));
    } catch (err) {
      console.error('[Sticky ATC] Add to cart failed:', err);
    } finally {
      const mainBtn = document.querySelector(`${this.formSel} button[data-add-to-cart]`);
      if (!mainBtn || !mainBtn.disabled) {
        this.btn.disabled = false;
      }
    }
  }
}

if (!customElements.get('sticky-mobile-bottom')) {
  customElements.define('sticky-mobile-bottom', StickyMobileBottom);
}
